import * as React from 'react';

import { IconProps } from './types';

const TopAlign: React.FC<IconProps> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M5 3h2c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1z" />
      <rect width="12" height="1" rx=".5" />
    </g>
  </svg>
);

export default TopAlign;
